import React from "react";
import "./styles.scss";
import { Divider, Button } from "@mui/material";

const OrderSummary = ({ data, handleCallSubmit, billingStatetrigger }) => {
  const { products, total } = data;
  return (
    <div className="checkout-summary-container">
      <h3>Order summary</h3>
      <Divider variant="middle" component="h3" />

      <div className="summary-section">
        {products?.length
          ? products?.map((item) => {
              return (
                <div key={item?.id}>
                  <p>
                    {item?.product_count} x {item?.name}
                  </p>
                  <span>
                    {item?.currency_symbol} {item?.total_price} {item?.currency}
                  </span>
                </div>
              );
            })
          : null}

        <div>
          <p>Shipping</p>
          <span>
            {total?.currency_symbol} {total?.shipping_cost} {total?.currency}
          </span>
        </div>

        {total?.tax_name && (
          <div>
            <p>{total?.tax_name}</p>
            <span>
              {total?.currency_symbol} {total?.tax_price} {total?.currency}
            </span>
          </div>
        )}
      </div>
      <Divider variant="middle" component="div" />
      <div className="total">
        <p>Total</p>
        <span>
          {total?.currency_symbol} {total?.total_amount} {total?.currency}
        </span>
      </div>
      {total?.payment_image && (
        <div className="image">
          <img src={total?.payment_image} alt="payment" />
        </div>
      )}

      <div className="btn">
        <Button
          disabled={billingStatetrigger}
          onClick={() => handleCallSubmit()}
          style={{
            opacity: billingStatetrigger ? "0.5" : 1,
          }}
        >
          Place order
        </Button>
      </div>
    </div>
  );
};

export default OrderSummary;
